module.exports = __webpack_public_path__ + "5379ba76dcc92efdafbad2f33215c449.svg";